import { FilterModifier } from "./FilterModifier"

export const NullableStringEqualsFilterModifier = FilterModifier.create<string | null, string | null>({
	id: "nullable-string-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NullableStringNotEqualsFilterModifier = FilterModifier.create<string | null, string | null>({
	id: "nullable-string-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringIncludesFilterModifier = FilterModifier.create<string, string>({
	id: "string-includes",
	getApplyFn: (filterValue) => (value) => {
		return value.includes(filterValue)
	},
	render: () => "includes",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringExcludesFilterModifier = FilterModifier.create<string, string>({
	id: "string-excludes",
	getApplyFn: (filterValue) => (value) => {
		return !value.includes(filterValue)
	},
	render: () => "does not include",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringArrayIncludesFilterModifier = FilterModifier.create<string, string[]>({
	id: "string-array-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringArrayExcludesFilterModifier = FilterModifier.create<string, string[]>({
	id: "string-array-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringArrayEveryFilterModifier = FilterModifier.create<string[], string[]>({
	id: "string-array-every",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			const valueSet = new Set(value)
			return filterValueSet.isSubsetOf(valueSet)
		}
	},
	render: () => "has all of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringArraySomeFilterModifier = FilterModifier.create<string[], string[]>({
	id: "string-array-some",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			const valueSet = new Set(value)
			return !filterValueSet.isDisjointFrom(valueSet)
		}
	},
	render: () => "has any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const StringArrayNoneFilterModifier = FilterModifier.create<string[], string[]>({
	id: "string-array-none",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			const valueSet = new Set(value)
			return filterValueSet.isDisjointFrom(valueSet)
		}
	},
	render: () => "has none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NullableStringArrayEqualsFilterModifier = FilterModifier.create<string[] | null, string[] | null>({
	id: "nullable-string-array-equals",
	getApplyFn: (filterValue) => {
		if (filterValue === null) return (value) => value === null
		const filterValueSet = new Set(filterValue)
		return (value) => {
			if (value === null) return false
			const valueSet = new Set(value)
			return valueSet.size === filterValueSet.size && filterValueSet.isSubsetOf(valueSet)
		}
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const NullableStringArrayNotEqualsFilterModifier = FilterModifier.create<string[] | null, string[] | null>({
	id: "nullable-string-array-not-equals",
	getApplyFn: (filterValue) => {
		if (filterValue === null) return (value) => value !== null
		const filterValueSet = new Set(filterValue)
		return (value) => {
			if (value === null) return true
			const valueSet = new Set(value)
			return valueSet.size !== filterValueSet.size || !filterValueSet.isSubsetOf(valueSet)
		}
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
